import { useQuery } from 'react-query';

import { getTopRecommendationChanges as queryFn } from 'api/endPoints/getTopRecommendationChanges';

import { IStatus } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryRecomendationTableData = (params) => {
    return useQuery<IRecomendationTableDataResponse, QueryError>(
        ['recomendationTableData', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
        },
    );
};

export interface IRecommendationResponse {
    id: number;
    title: string;
    status: IStatus;
    assignee: {
        id: -1;
        userName: 'Unassigned';
        firstName: 'Unassigned';
        lastName: '';
        imageName: '';
    };
    isVirtual: boolean;
    originalStatus: IStatus | null;
    type: {
        id: number;
        name: string;
        label: string;
    };
    category: {
        id: number;
        name: string;
        label: string;
    };
    startDate: number;
    endDate: number;
    duration: number;
    severity: string;
}

export interface IRecomendationTableDataResponse {
    title: string;
    recommendationResponse: IRecommendationResponse[];
    info: IToolTip;
    typeId: string;
}
